// import { async } from '@angular/core/testing';

import { Component, TemplateRef, ViewChild, HostListener, ElementRef } from '@angular/core';
import { AvatarComponent } from "../avatar/avatar.component";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { common } from '../../../core/constants/common';
import { AppStorage } from '../../../core/utilities/app-storage';
import { InitialService } from '../../../core/services/initial/initial.service';
import { SessionData } from './header.interface';
import { WebSocketService } from '@11za/app/core/services/websocket/websocket.service';
import { QueueService } from '@11za/app/core/services/queue/queue.service';
import { environment } from '@11za/environments/env.dev';
import { AllTeams, OnLIneStatusPayload } from '../../pages/master/components/team-members/team-members/team-members.interface';
import { FormsModule } from '@angular/forms';
import { MasterService } from '@11za/app/core/services/master/master.service';
import { swalHelper } from '@11za/app/core/constants/swal-helper';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChatService } from '@11za/app/core/services/chat/chat.service';
// import { CookieService } from 'ngx-cookie-service';
import { Helper } from '@11za/app/core/utilities/helper';
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { OpenMatDialogService } from '@11za/app/core/services/helper/openMatDialog.service';
import { DebounceDirective } from '@11za/app/core/directives/debounce';
// import { CustomersService } from '@11za/app/core/services/customers/customers.service'; // moved to default-page.component.ts


@Component({
  selector: 'app-header',
  imports: [AvatarComponent, CommonModule, RouterModule, FormsModule, NgSelectModule, MatTooltipModule, MatMenuModule, MatButtonModule, MatDividerModule, DebounceDirective],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isOnline = true;
  forClient = environment.forClient
  baseURL = environment.baseURL
  currentRoute: string = '';
  isMenuOpen: boolean = false;
  userName: string = 'Username';
  selectedTeam: any = null;
  @ViewChild('onLIneStatusModal') onLIneStatusModal!: TemplateRef<any>;
  @ViewChild('globalSearchInput') globalSearchInput!: ElementRef;
  teamMember: any = {};
  onlinestatusdata: any;
  mid: any;
  storeValues: any;
  globalSearchQuery: string = '';
  searchResults: any[] = [];
  showDropdown: boolean = false;
  isSearching: boolean = false;
  isSearchInputVisible: boolean = false;
  constructor(private router: Router,
    private storage: AppStorage,
    public initialService: InitialService,
    private webSocketService: WebSocketService,
    private queueService: QueueService,
    // private cookieService: CookieService,
    private masterService: MasterService,
    private OpenMatDialogService: OpenMatDialogService,
    private chatService: ChatService,
    private helper: Helper,
    // private customersService: CustomersService // moved: cost-cap "Spend Limit" badge now lives on default-page, not header
  ) {
  }

  // Cost capping (end customer spend limit) - moved to default-page.component.ts (shown under the
  // "Welcome, {name}" heading instead of the header nav), keeping this commented out per convention.
  // costCapExceededCount = 0;
  // costCapNearLimitCount = 0;
  // fetchCostCapSummary(): void {
  //   this.customersService.costCappingSummary()
  //     .then((res: any) => {
  //       this.costCapExceededCount = res?.Data?.exceededCount || 0;
  //       this.costCapNearLimitCount = res?.Data?.nearLimitCount || 0;
  //     })
  //     .catch((err: any) => console.log(err));
  // }
  onLIneStatusPayload: OnLIneStatusPayload = {
    mmid: '',
    status: '',
  };
  assignToOne = true;
  isDarkColor(hex?: string): boolean {
    if (!hex) return false; // Default to light text on white background

    // Convert shorthand colors like #FFF to full form #FFFFFF
    if (hex.length === 4) {
      hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }

    // Extract RGB values
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // Calculate relative luminance (standard formula)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    return luminance < 128; // Dark if luminance is below 128
  }

  queuechatsPermission = true
  endcustomersPermission = true
  broadcastsPermission = true
  templatesPermission = true
  autorepliesPermission = true
  quickReplyPermission = true;
  interactiveMessagePermission = true;
  rolesPermission = true;
  logsPermission = true;
  walletPermission = true;
  permission = true;
  messagelink = true;
  fileUploaderPermission = true;
  optInSettingPermission = true;
  teamsPermission = true;
  teamMembersPermission = true;
  companyProfilePermission = true;
  settingsPermission = false;
  compaignFlowPermission = false;
  allowedIpsPermission = false;
  loginLogsPermission = false;
  activityLogsPermission = false;
  isSuperAdmin = false;
  setPermission = async () => {
    this.initialService.getPermission.subscribe((e) => {
      if (e?.queuechats) this.queuechatsPermission = e.queuechats.view
      if (e?.endcustomers) this.endcustomersPermission = e.endcustomers.view
      if (e?.broadcasts) this.broadcastsPermission = e.broadcasts.view
      if (e?.templates) this.templatesPermission = e.templates.view
      if (e?.autoreplies) this.autorepliesPermission = e.autoreplies.view
      if (e?.quickreplies) this.quickReplyPermission = e.quickreplies.view
      if (e?.listmessages) this.interactiveMessagePermission = e.listmessages.view
      if (e?.roles) this.rolesPermission = e.roles.view
      if (e?.messagelogs) this.logsPermission = e.messagelogs.view
      if (e?.walletrequests) this.walletPermission = e.walletrequests.view
      if (e?.permissions) this.permission = e.permissions.view
      if (e?.messagelink) this.messagelink = e.messagelink.view
      if (e?.fileuploaders) this.fileUploaderPermission = e.fileuploaders.view
      if (e?.optinsetting) this.optInSettingPermission = e.optinsetting.view
      if (e?.ourteams) this.teamsPermission = e.ourteams.view
      if (e?.customerteammembers) this.teamMembersPermission = e.customerteammembers.view
      if (e?.companyProfile) this.companyProfilePermission = e.companyProfile.view
      if (e?.settings) this.settingsPermission = e.settings.view
      if (e?.campaignFlow) this.compaignFlowPermission = e.campaignFlow.view
      if (e?.allowedips) this.allowedIpsPermission = e.allowedips.view
      if (e?.loginlogs) this.loginLogsPermission = e.loginlogs.view
      if (e?.activitylogs) this.activityLogsPermission = e.activitylogs.view
    })
  }
  isMultiLogin = false
  async ngOnInit() {
    this.initialService.session$.subscribe((session: any) => {
      if (session?.onlineStatus != undefined) this.isOnline = session.onlineStatus
      this.userName = session?.name || 'Username'
      this.mid = session?._id || session?.mid || null;
      if (session?.isSuperAdmin != undefined) this.isSuperAdmin = session.isSuperAdmin
    })
    await this.getSessionData()
    await this.setPermission()
    this.initialService.setPermission()
    //     await this.initialService.getPermission.subscribe((e) => {
    //   if (e?.broadcasts) this.Permission = e.broadcasts
    // })
    this.currentRoute = window.location.pathname;
    this.router.events.subscribe(() => {
      // Get the current active route
      let splittedRoute = this.router.url.split('/');
      if (splittedRoute.length >= 1) {
        this.currentRoute = this.router.url.split('/')[1] || '';
      }
    });

    this.userName = this.storage.SessionStorageGet(common.USER_NAME) || 'Username';
    this.webSocketService.parentUnseenCounterChatNew()
    this.getQueuedCustomersCount()
    this.webSocketService.headerCountAndChat$.subscribe((message) => {
      this.haderCoundtAndchat = message;
    });
    this.queueChatsCount();
    // this.fetchCostCapSummary(); // moved to default-page.component.ts

    const data = await this.initialService.singleteamMember()
    this.isMultiLogin = data.Data.isMultiLogin

    this.chatService.qCount$.subscribe((count) => {
      this.qCount = count;
    });

    this.chatService.globalSearchQuery$.subscribe(query => {
      // Keep this sync if needed elsewhere, but avoid immediate search here
      this.globalSearchQuery = query;
    });
  }

  async onGlobalSearch() {
    if (!this.globalSearchQuery || !this.globalSearchQuery.trim()) {
      this.searchResults = [];
      this.showDropdown = false;
      return;
    }

    this.isSearching = true;
    this.showDropdown = true;

    try {
      const payload = {
        page: 1,
        limit: 10,
        search: this.globalSearchQuery.trim()
      };
      const res = await this.chatService.getGlobalSearch(payload);
      if (res.IsSuccess) {
        this.searchResults = res.Data?.docs || res.Data || [];
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.isSearching = false;
    }
  }

  openChat(chat: any) {
    this.closeSearchInput();

    // Determine target tab
    const targetTab = this.getTargetTabForGlobalChat(chat);

    this.chatService.updateFilter({
      search: '',
      customerChatStatus: 'all',
      isUnreadChat: false,
      selectedTags: [],
      selectedLabel: [],
      selectedTeamMembers: [],
      selectedTeams: [],
    });
    this.chatService.setPreviewListType(targetTab, true);

    this.chatService.selectUser(chat);

    if (!this.isActive('/chats')) {
      this.router.navigateByUrl('/chats');
    }
  }

  private getTargetTabForGlobalChat(chat: any): string {
    const teamMemberReply = chat?.groupData?.teamMemberReply;
    const teamId = chat?.groupData?.teamId;
    const myId = this.mid;

    if (!teamMemberReply && !teamId) {
      return 'queue';
    }

    if (teamMemberReply?.queueMember) {
      return 'queue';
    }
    if (teamMemberReply?.name === "Queue Team Member") {
      return 'queue';
    }

    if (teamId) {
      return 'team';
    }

    const memberId = typeof teamMemberReply === 'object' ? teamMemberReply?._id : teamMemberReply;
    if (memberId && memberId === myId) {
      return 'your';
    } else if (memberId && memberId !== myId) {
      return 'admin';
    }
    return 'your';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.global-search-container')) {
      this.showDropdown = false
      if (!this.globalSearchQuery.trim()) {
        this.isSearchInputVisible = false;
      }
    }
  }

  openSearchInput() {
    this.isSearchInputVisible = true;
    setTimeout(() => {
      if (this.globalSearchInput && this.globalSearchInput.nativeElement) {
        this.globalSearchInput.nativeElement.focus();
      }
    }, 50);
  }

  closeSearchInput() {
    this.isSearchInputVisible = false;
    this.globalSearchQuery = '';
    this.showDropdown = false;
    this.searchResults = [];
  }

  qCount: any = 0
  queueChatsCount() {
    this.webSocketService.queueChatsCount.subscribe(() => {
      this.getQueuedCustomersCount()
    });
  }
  getQueuedCustomersCount() {
    this.queueService.getQueuedCustomersCount().then((res) => {
      this.qCount = res.Data
      this.chatService.setQCount(res.Data)
    })
  }
  haderCoundtAndchat: any = {
    totalChates: 0,
    yourChat: 0,
    otherChat: 0
  }

  isActive(route: string): boolean {
    if (route && (route.includes(this.currentRoute) || this.currentRoute.includes(route))) {
      return true;
    }
    return false;
  }

  toggleMenu() {
    const menu = document.getElementById('mobile-menu');
    if (menu) {
      menu.classList.toggle('tw-hidden');
      this.isMenuOpen = !this.isMenuOpen;

    }
  }

  getSessionData = async () => {
    try {
      let response: SessionData | number = await this.initialService.sessionData();
      if (response) {
        this.storage.SessionStorageSet(common.USER_NAME, response.name);
        this.storage.SessionStorageSet(common.CHANNEL_ID, response.channelId);
        this.storage.SessionStorageSet(common.USER_ROLE, response.roleIdname);
        this.storage.SessionStorageSet(common.UNIQ_USER_ID, response._id);
        await this.initialService.setUserType()
        await this.webSocketService.initializeWebSocket()
        await this.initialService.getdataStore()
        await this.initialService.checkNumberMasking()
        // await this.initialService.singleteamMember()
      }
    } catch (e) {
      console.log('catch perform error is ', e)
      this.storage.LogOutSession();
      if (this.router.url.split('/').includes('403') || this.router.url.split('/').includes('iframe')) {
        this.router.navigateByUrl('/iframe/403');
      } else {
        this.router.navigateByUrl('/login');
      }
    }
  }

  async onOnlineStatusChange() {
    if (!this.teamMember.onlineStatus) {
      await Promise.all([this._getAllTeams(), this._getTeamMemberforAssign()]);
      this.allTeamMembersFull = [...this.allTeamMembers];
    }

    this.offlineMemberSelect = null;
    this.selectedTeam = null;
  }

  onAssignTypeChange() {
    this.offlineMemberSelect = null
    this.selectedTeam = null;
    if (this.assignToOne) {
      this.allTeamMembers = [...this.allTeamMembersFull];
    }
    // if (this.assignToOne) {
    //   this._getTeamMemberforAssign();
    // } else {
    //   this._getAllTeams();
    // }
  }
  TeamIdForDelet: string = '';
  offlineMemberSelect: any = null;
  allTeamMembers: any[] = [];
  allTeamMembersFull: any[] = [];
  allTeams: AllTeams[] = [];
  _getTeamMemberforAssign = async (teamId?: any): Promise<any> => {
    this.offlineMemberSelect = null;
    try {
      let response = await this.masterService.getTeamMeberForAssign({
        teamId: teamId,
      });
      if (response.IsSuccess == true) {
        this.TeamIdForDelet = teamId;
        if (teamId) {
          this.allTeamMembers = response.Data;
        } else {
          this.allTeamMembers = response.Data;
          this.allTeamMembersFull = [...response.Data];
        }
      }
    } catch (error) {
      swalHelper.error(error);
    }
  };
  _getAllTeams = async (): Promise<any> => {
    try {
      /* 👎👎👎 */
      let response = await this.masterService.getAllTeams({});
      if (response.IsSuccess == true) {
        this.allTeams = response.Data;
      }
    } catch (error) {
      swalHelper.error(error);
    }
  };
  getTeammember = async (): Promise<any> => {
    try {
      let response = await this.masterService.singleTeamMember({});
      if (response.IsSuccess == true) {
        this.teamMember = response.Data;
        this.mid = this.teamMember._id
      }
    } catch (error) {
      swalHelper.error(error);
    }
  };

  getOnlineStatusData = async (): Promise<any> => {
    try {
      let response = await this.initialService.getOnlineStatusData();
      if (response.IsSuccess == true) {
        // this.onlinestatusdata = response.Data?.offlineAssign;
        return response
      }
    } catch (error) {
      swalHelper.error(error)
    }

  }

  deletClassinstance = new deletClass();
  saveOnlineStatus() {
    const member = this.deletClassinstance.member;

    const payload = {
      mid: this.mid /* || this.sessionData._id */,
      status: this.teamMember.onlineStatus,
      offlineAssign: {
        assignType: this.assignToOne ? 'ato' : 'att',
        teamId: this.assignToOne ? '' : this.TeamIdForDelet || '',
        memberIds: this.assignToOne
          ? []
          : this.allTeamMembers
            ?.filter((e) => e._id !== member._id)
            .map((e) => e._id) || [],
        replyMemberId: this.offlineMemberSelect,
      },
    };
    this.masterService
      .saveOnlineStatus(payload)
      .then((result: any) => {

        this.OpenMatDialogService.closeDialog()
        swalHelper.success(
          'Online Status',
          'Status has been changed successfully'
        );
        this.isOnline = this.teamMember.onlineStatus
        // this.initialService.singleteamMember()
      })
      .catch((err: any) => {
        swalHelper.error(
          err || '🤔 something wrong try later or inform to admin'
        );
      });
  }
  closeModel() {
    if (this.storeValues) {
      this.teamMember = JSON.parse(JSON.stringify(this.storeValues.teamMember));
      this.assignToOne = this.storeValues.assignToOne;
      this.offlineMemberSelect = this.storeValues.offlineMemberSelect;
      this.selectedTeam = this.storeValues.selectedTeam;

      this.isOnline = this.teamMember.onlineStatus;
    }
    this.OpenMatDialogService.closeDialog()
  }

  async onOpenLLineStatusModal() {
    this.teamMember.onlineStatus = this.isOnline;
    if (!this.isOnline) {
      const response = await this.getOnlineStatusData();
      if (response?.IsSuccess) {
        const offlineAssign = response?.Data?.offlineAssign;
        this.assignToOne = offlineAssign?.assignType === 'ato';

        await Promise.all([
          this._getAllTeams(),
          this._getTeamMemberforAssign()
        ]);

        const teamExists = this.allTeams.some(
          (e: any) => e._id === offlineAssign?.teamId
        );
        this.selectedTeam = teamExists ? offlineAssign?.teamId : null;

        // if (this.selectedTeam) {
        //   await this._getTeamMemberforAssign(this.selectedTeam);
        // }
        if (this.selectedTeam && offlineAssign?.memberIds?.length) {
          this.allTeamMembers = this.allTeamMembersFull.filter((m: any) =>
            offlineAssign.memberIds.includes(m._id)
          );
        }
        const memberExists = this.allTeamMembers.some(
          (e: any) => e._id === offlineAssign?.replyMemberId
        );
        this.offlineMemberSelect = memberExists ? offlineAssign.replyMemberId : null;
      }
    }
    this.storeValues = {
      teamMember: JSON.parse(JSON.stringify(this.teamMember)),
      assignToOne: this.assignToOne,
      offlineMemberSelect: this.offlineMemberSelect,
      selectedTeam: this.selectedTeam
    };
    this.OpenMatDialogService.openDialog(this.onLIneStatusModal, {
      width: '600px',
      height: 'auto',
    });
    // this.onLIneStatusPayload.mmid = this.deletClassinstance.member._id;
    // console.log("??this.onLIneStatusPayload??", this.onLIneStatusPayload);
    // this.onLIneStatusPayload.status = false /* member.onlineStatus; */
    // this.modals.open('onLIneStatusModal')
  }

  // async logout() {
  //   // this.cookieService.delete('accessToken');
  //   await this.initialService.logout()
  //   this.storage.LogOutSession();
  //   this.router.navigateByUrl('/login');
  // }

  async logout() {
    try {

      await this.initialService.logout();
      // this.cookieService.delete(common.ACCESS_TOKEN)
      this.storage.LogOutSession();
      localStorage.removeItem('qr_sort_filter');
      this.router.navigateByUrl('/login').then(() => {
        window.location.reload();
      });

    } catch (error) {
      console.error('Logout failed:', error);
      // this.cookieService.delete(common.ACCESS_TOKEN)
      this.storage.LogOutSession();
      this.router.navigateByUrl('/login').then(() => {
        window.location.reload();
      });
    }
  }

  chatRouter() {
    this.chatService.selectUser(null)
    this.router.navigateByUrl('/chats')
    this.installPWA();
  }
  deferredPrompt: any = null;
  installPWA() {
    // Check if PWA is already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || (window.navigator as any).standalone === true;

    if (isStandalone) {
      console.log('App is already installed.');
      return; // Do nothing if already installed
    }
    if (this.deferredPrompt) {
      // Show confirmation to user (optional)
      const userConfirmed = confirm('Do you want to install this app?');
      if (userConfirmed) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult: { outcome: string }) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('PWA installation accepted');
          } else {
            console.log('PWA installation dismissed');
          }
          this.deferredPrompt = null;
        });
      }
    } else {
      console.log('Install prompt not available.');
    }
  }

  async switchAccount() {
    const result = await this.initialService.switchAccount();
    if (result?.parentAccountDetails?.length && result?.userData) {
      await this.initialService.logout();
      // this.cookieService.delete(common.ACCESS_TOKEN)
      this.storage.LogOutSession();
      this.storage.clearAll();
      this.storage.SessionStorageSet('switchAccountData', {
        parentAccountDetails: result.parentAccountDetails,
        userData: result.userData,
        pickerToken: result.pickerToken
      });
      window.location.href = '/parent-account';
      return
    }
  }

}

class deletClass {
  member: any = '';
}
